import { render } from "./Plan.vue?vue&type=template&id=3f213986&scoped=true"
import script from "./Plan.vue?vue&type=script&lang=ts"
export * from "./Plan.vue?vue&type=script&lang=ts"

import "./Plan.vue?vue&type=style&index=0&id=3f213986&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3f213986"

export default script